import {
  Smartphone,
  MessageSquare,
  Shield,
  Zap,
  Globe,
  Heart,
} from "lucide-react"

const features = [
  {
    icon: Smartphone,
    title: "Works everywhere",
    description:
      "Access Corkboard via our Progressive Web App, public website, or WhatsApp. Whatever suits you best.",
    highlight: false,
  },
  {
    icon: MessageSquare,
    title: "WhatsApp integration",
    description:
      "Retailers can submit listings by simply messaging our bot. No logins, no learning curve. Just chat.",
    highlight: true,
  },
  {
    icon: Shield,
    title: "Privacy-first AI",
    description:
      "Our AI runs on local infrastructure, keeping your data in your community. No big tech, no surveillance.",
    highlight: false,
  },
  {
    icon: Zap,
    title: "Always fresh",
    description:
      "Time-based content automatically expires, so you only see what's actually happening now.",
    highlight: false,
  },
  {
    icon: Globe,
    title: "Truly local",
    description:
      "Set your own radius for discovery. From your street to your whole town, you're in control.",
    highlight: true,
  },
  {
    icon: Heart,
    title: "Community-owned",
    description:
      "Built with and for local communities. Transparent, open, and designed to serve, not extract.",
    highlight: false,
  },
]

export function Features() {
  return (
    <section id="features" className="py-24 md:py-32 bg-forest text-cream">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm font-medium text-amber uppercase tracking-wider mb-4">
            Features
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-semibold mb-6 text-balance">
            Technology that respects your community
          </h2>
          <p className="text-lg text-cream/80 leading-relaxed">
            Every feature is designed with accessibility, privacy, and genuine community
            benefit in mind.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => {
            const Icon = feature.icon
            return (
              <div
                key={feature.title}
                className={`p-6 rounded-2xl transition-all duration-300 hover:scale-[1.02] ${feature.highlight
                    ? "bg-amber text-foreground"
                    : "bg-forest-light/20 hover:bg-forest-light/30"
                  }`}
              >
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${feature.highlight
                      ? "bg-foreground/10 text-foreground"
                      : "bg-cream/10 text-cream"
                    }`}
                >
                  <Icon className="w-6 h-6" />
                </div>
                <h3
                  className={`font-semibold text-lg mb-3 ${feature.highlight ? "text-foreground" : "text-cream"
                    }`}
                >
                  {feature.title}
                </h3>
                <p
                  className={`leading-relaxed text-sm ${feature.highlight ? "text-foreground/80" : "text-cream/70"
                    }`}
                >
                  {feature.description}
                </p>
              </div>
            )
          })}
        </div>

        {/* Bottom Note */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-forest-light/20 px-6 py-4 rounded-2xl">
            <Shield className="w-5 h-5 text-amber" />
            <p className="text-sm text-cream/90">
              <span className="font-semibold">Responsible AI commitment:</span> All AI
              features are transparent, explainable, and run on community-controlled
              infrastructure.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
